@if(isLoginModal){
    <app-login-signup-home 
        *ngIf="!signup && !login && !forgotPassword" 
        [isLoginModal]="isLoginModal"
        (authAction)="handleAuthAction($event)">
    </app-login-signup-home>
    <app-create-user 
        *ngIf="signup" 
        [isLoginModal]="isLoginModal" 
        (goBackPage)="goBackPage($event)"
        (authAction)="handleAuthAction($event)">
    </app-create-user>
    <app-signin 
        *ngIf="login" 
        [isLoginModal]="isLoginModal" 
        (goBackPage)="goBackPage($event)"
        (forgotPasswordPage)="handleAuthAction($event)">
    </app-signin>
    <app-forgot-password 
        *ngIf="forgotPassword" 
        [isLoginModal]="isLoginModal"
        (goBackPage)="handleAuthAction($event)">
    </app-forgot-password>
} @else {
    <ion-router-outlet></ion-router-outlet>
}